import { ToastContainer } from '../../components/Common';
import DealerInvoiceDetailsPage from './page';

const DealerInvoiceDetailsPageWrapper = () => {
	return (
		<>
			<div className="page-content">
				<DealerInvoiceDetailsPage />
			</div>
			<ToastContainer />
		</>
	);
};

export default DealerInvoiceDetailsPageWrapper;
